<mat-card>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between">
    {{ market.name }}
    <div class="buttons">
      <button mat-raised-button color="primary" class="primary-button" (click)="viewMarket()" aria-label="Voir les documents">Voir les documents</button>
      <button mat-raised-button color="primary" class="secondary-button" (click)="editMarket()" aria-label="Éditer">Éditer</button>
    </div>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content fxLayout="row" fxLayoutAlign="space-between" >
      <img src="assets/icons/{{market.icon}}" alt="homepage" width="60" height="60">
      <div class="buttons">
          <mat-icon *ngIf="market.order !== 1" (click)="changeOrderUp()">arrow_upward_alt</mat-icon>
          <mat-icon *ngIf="market.order !== markets.length" (click)="changeOrderDown()">arrow_downward_alt</mat-icon>
      </div>
  </mat-card-content>
</mat-card>
  